import { API_ENDPOINTS } from '../config/api.config';
import httpService from './http.service';

class StepSelectionService {
  // Soumettre les sélections d'une étape
  async submitStepSelections(demandeId, stepId, selections) {
    try {
      console.log('Soumission des sélections pour l\'étape:', stepId, selections);
      
      // Endpoint pour soumettre les sélections d'une étape
      const endpoint = `/be/my-demandes/${demandeId}/steps/${stepId}/selections/`;
      
      const response = await httpService.post(endpoint, {
        step_id: stepId,
        selections: selections,
        submitted_at: new Date().toISOString(),
      });
      
      console.log('Sélections soumises avec succès:', response);
      return {
        success: true,
        data: response,
      };
    } catch (error) {
      console.error('Erreur lors de la soumission des sélections:', error);
      return {
        success: false,
        error: error.message || 'Erreur lors de la soumission des sélections',
      };
    }
  }

  // Soumettre les sélections de toutes les étapes
  async submitAllStepSelections(demandeId, allSelections) {
    try {
      console.log('Soumission de toutes les sélections:', allSelections);
      
      const results = [];
      
      // Soumettre les sélections pour chaque étape
      for (const [stepId, selections] of Object.entries(allSelections)) {
        if (selections && selections.length > 0) {
          const result = await this.submitStepSelections(demandeId, stepId, selections);
          results.push({
            stepId,
            success: result.success,
            data: result.data,
            error: result.error,
          });
        }
      }
      
      const successCount = results.filter(r => r.success).length;
      const totalCount = results.length;
      
      console.log(`Sélections soumises: ${successCount}/${totalCount}`);
      
      return {
        success: successCount === totalCount,
        data: results,
        summary: {
          total: totalCount,
          successful: successCount,
          failed: totalCount - successCount,
        },
      };
    } catch (error) {
      console.error('Erreur lors de la soumission de toutes les sélections:', error);
      return {
        success: false,
        error: error.message || 'Erreur lors de la soumission de toutes les sélections',
      };
    }
  }

  // Récupérer les sélections d'une étape
  async getStepSelections(demandeId, stepId) {
    try {
      const endpoint = `/be/my-demandes/${demandeId}/steps/${stepId}/selections/`;
      const response = await httpService.get(endpoint);
      
      return {
        success: true,
        data: response,
      };
    } catch (error) {
      console.error(`Erreur lors de la récupération des sélections de l'étape ${stepId}:`, error);
      return {
        success: false,
        error: error.message,
      };
    }
  }

  // Récupérer toutes les sélections d'une demande
  async getAllSelections(demandeId) {
    try {
      const endpoint = `/be/my-demandes/${demandeId}/selections/`;
      const response = await httpService.get(endpoint);
      
      return {
        success: true,
        data: response,
      };
    } catch (error) {
      console.error(`Erreur lors de la récupération de toutes les sélections:`, error);
      return {
        success: false,
        error: error.message,
      };
    }
  }
}

// Instance singleton
export const stepSelectionService = new StepSelectionService();
export default stepSelectionService;